import { Injectable, Type } from '@angular/core';
import { DeletableEffectSources } from './deletable-effect-sources';
import { IEffect } from './effect.interface';
import { UnicEffectsAvailableEnum } from './deletable-effect-sources.constant';
import { Store } from '@ngrx/store';
import { EffectsListReducerState } from '../../reducers/effects-list.reducer';
import { EffectsList } from '../../constants/effects-list';
import { getEffectsList } from '../../selectors/effects-list.selector';
import { take } from 'rxjs/operators';

export const NGRX_EFFECTS_PROPS_KEY = '__@ngrx/effects__';

/**
 * Service to avoid effect executions when similar action is dispatched
 * and the effect is not registered in the list (effectsListAvailable)
 * The effects registered are the ones coming from form configurations
 */
@Injectable()
export class EffectsRegistrationService {
  /**
   * Stores effects availables
   */
  private effectsRegistrationList: string[] = [];

  private mainEffectsList: EffectsList;

  constructor(
    private deletableEffectSources: DeletableEffectSources,
    private store: Store<EffectsListReducerState>,
  ) {
    // this.store.dispatch(new EffectsCreateListAction());
    this.store
      .select(getEffectsList)
      .pipe(take(2))
      .subscribe((effectsList) => {
        if (Object.keys(effectsList).length) {
          this.mainEffectsList = effectsList;
        }
      });
  }

  /**
   * Add effects to the list (effectsListAvailable)
   * @param {Type<IEffect>[]} effectSourceInstance
   */
  public addEffects(effectSourceInstance: Type<IEffect>[]) {
    const name = this.deletableEffectSources.getEffectId(effectSourceInstance);
    if (!this.effectsRegistrationList.includes(name)) {
      this.effectsRegistrationList.push(name);
    }
  }

  /**
   * Deletes multiple effects from list (effectsListAvailable)
   * @param {Type<IEffect>[]} effectSourceType
   */
  public deleteEffects(effectSourceType: Type<IEffect>[]) {
    effectSourceType.forEach((effectType) => {
      this.deleteEffect(effectType);
    });
  }

  /**
   * Deletes the effect from list (effectsListAvailable)
   * @param {Type<IEffect>[]} effectSourceType
   */
  public deleteEffect(effectSourceType: Type<IEffect>) {
    this.effectsRegistrationList = this.effectsRegistrationList.filter((effectId) => {
      const constructor = effectSourceType.prototype.constructor;
      return effectId !== constructor.name + JSON.stringify(constructor[NGRX_EFFECTS_PROPS_KEY]);
    });
  }

  /**
   * Clears effects registered
   */
  public clearEffectsRegistered() {
    this.effectsRegistrationList = [];
  }

  /**
   * Review in the list effectsWhiteList if the effect is available to be used, if it is
   * the effect will be able to execute its action
   * @param {UnicEffectsAvailableEnum} effectName Effect name to review if it is available
   * @returns {boolean}
   */
  public isEffectAvailable(effectName: UnicEffectsAvailableEnum): boolean {
    const effectExecuted = this.mainEffectsList[effectName];
    const isEffectAvailable = this.effectsRegistrationList.some((effectId) => {
      return effectId === effectExecuted;
    });
    return isEffectAvailable;
  }
}
